<template>
    <div id="app" :class="sidebarClose?'is-close':''">
        <el-container>
            <el-header id="app-header">
                <hd v-model="sidebarClose"></hd>
            </el-header>
            <el-container id="main-container">
                <el-aside width="210px">
                    <sidebar></sidebar>
                </el-aside>
                <el-container>
                    <el-main>
                        <slot></slot>
                    </el-main>
                    <el-footer>

                    </el-footer>
                </el-container>

            </el-container>
        </el-container>

    </div>
</template>
<script>
    export default {
        name: "app",
        components: {
            sidebar: require('./siderbar').default,
            hd: require('./header').default
        },
        data() {
            return {
                sidebarClose: false
            }
        },
        mounted() {
            console.log(window.location.href)
        },
        methods: {}
    }
</script>
<style lang="scss">

    body {
        margin: 0;
        background-color: #f0f0f0;
    }

    #app {
        font-family: 'Open Sans', 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        background-color: #f0f0f0;
    }

    #app {
        .el-alert__content {
            p {
                font-size: 12px;
                margin: 5px 0;
            }
        }

        .section {
            padding: 10px;
        }

        #main-container {
            padding-left: 220px;
            margin-top: 70px;
        }

        #app-header {
            border-bottom: 1px solid #f1f2f7;
            display: flex;
            align-items: center;
            height: 60px;
            width: 100%;
            background-color: #fff;
            z-index: 1000;
            position: fixed;

            .icon-reorder {
                font-size: 20px;
            }

            .sidebar-toggle-box {
                float: left;
            }
        }
    }

    #app.is-close {
        .el-aside {
            margin-left: -220px;
        }

        #main-container {
            padding-left: 0;
        }
    }

    #app {
        a {
            text-decoration: none
        }


        .el-main {
            padding: 0 15px 0 0;
        }

        .el-row {
            background-color: #fff;
            margin-bottom: 15px;
        }

        .el-alert {
            text-align: left;
            margin-bottom: 10px;

        }

        .pagination {
            margin-top: 10px;
            text-align: right;
        }

    }

</style>

